export type ActorType = 'user' | 'organization_admin' | 'admin' | 'system';

export interface ChatActorOrganization {
  id: number;
  name: string;
}

export interface ChatActorType {
  id: number;
  type?: ActorType;
  fullName: string;
  firstName: string;
  lastName: string;
  smallAvatar?: string | null;
  deletedAt?: string | null;
  inactiveAt?: string | null;
  organization?: ChatActorOrganization | null;
}

export interface ChatMessageType {
  id: string;
  text: string;
  createdAt: string;
  senderActorId: number;
  __typename?: 'ChatMessage';
}

export type LatestChatMessageType = Omit<ChatMessageType, 'senderActorId'>;

export enum ChatEventTypeEnum {
  PARTICIPANTS_CHANGED = 1,
  CHAT_ARCHIVED = 2,
  CHAT_UNARCHIVED = 3,
}

export enum ChatEventChangeTypeEnum {
  ADDED = 1,
  REMOVED = 2,
  REACTIVATED = 3,
}

// Actor type for event targets - includes name for display
export interface ChatEventActorType {
  id: number;
  fullName: string;
}

export interface ChatEventTargetType {
  id: string;
  targetActorId: number;
  chatEventChangeTypeId: ChatEventChangeTypeEnum;
  targetActor: ChatEventActorType;
}

export interface ChatEventItemType {
  id: string;
  createdAt: string;
  chatId: string;
  chatEventTypeId: ChatEventTypeEnum;
  targets: ChatEventTargetType[];
  __typename: 'ChatEvent';
}

export type ChatTimelineItem = ChatMessageType | ChatEventItemType;

export interface ChatType {
  id: string;
  participants: ChatActorType[];
  activeNonViewerParticipants?: ChatActorType[];
  isActive: boolean;
  archivedAt?: string | null;
}

export interface ChatWithLatestMessageType extends ChatType {
  latestChatMessage?: LatestChatMessageType | null;
}

export interface ViewerActorType {
  id: number;
}

export interface ChatSocketErrorPayload {
  message: string;
}
